import { useEffect, useState, useRef } from 'react'

interface UseScrollProgressOptions {
  offset?: [string, string] // e.g., ["start end", "end start"]
}

export function useScrollProgress(options: UseScrollProgressOptions = {}) {
  const [scrollProgress, setScrollProgress] = useState(0)
  const targetRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const target = targetRef.current
    if (!target) return

    const handleScroll = () => {
      const rect = target.getBoundingClientRect()
      const windowHeight = window.innerHeight
      
      // Calculate progress based on element position
      const elementTop = rect.top
      const elementHeight = rect.height
      
      // Start when element enters viewport, end when it leaves
      const startOffset = windowHeight
      const endOffset = -elementHeight
      
      const totalDistance = startOffset - endOffset
      const currentPosition = startOffset - elementTop
      
      const progress = Math.max(0, Math.min(1, currentPosition / totalDistance))
      setScrollProgress(progress)
    }

    handleScroll() // Initial calculation
    window.addEventListener('scroll', handleScroll, { passive: true })
    window.addEventListener('resize', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', handleScroll)
    }
  }, [])

  return { ref: targetRef, scrollProgress }
}

export function useScrollY() {
  const [scrollY, setScrollY] = useState(0)

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY)
    
    handleScroll() // Initial value
    window.addEventListener('scroll', handleScroll, { passive: true })
    
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return scrollY
}